import * as React from "react";
import {FBColumn} from "./FBColumn";
import {FBRowModel} from "FormBuilder/Core/FBRow.Model";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";

export class FBRow extends React.Component<FBRowProps, FBRowState> {
    static defaultProps: Partial<FBRowProps> = {};
    public Instance:HTMLDivElement;
    public Column:FBColumn;
    constructor(props: FBRowProps) {
        super(props);
        this.state = {};
        this.RenderRefUpdated=this.RenderRefUpdated.bind(this);

    }

    componentDidMount(): void {
        this.props.Model.OnRefresh.Subscribe(this,()=>this.forceUpdate());
    }

    public RenderRefUpdated(x:any)
    {
        if(x==null)
            return;
        this.props.Model.Instance=x;
    }


    public render() {

        return (
            <div ref={this.RenderRefUpdated} className={'rednaoWooRow '+(this.props.Model.Columns.length>1?'rnMultiColumn':'')}>
                {this.props.Model.Columns.map(x=>
                    this.GetColumn(x.Field.Options.Id,x)
                )}
            </div>
        )
    }

    public GetColumn(key:any,options:FBColumnModel)
    {
        return <FBColumn   key={key} Model={options} />
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface FBRowProps {
    Model:FBRowModel;

}


export interface FBRowState {

}

//#endregion "My Region"

/*

import {FBRowOptions} from "./FBRow.Options";
import {FBColumn} from "./FBColumn";
import {FormBuilder} from "./FormBuilder";

export class FBRow {
    public Options:FBRowOptions;
    public Columns:FBColumn[];
    public Container:HTMLDivElement;
    public FormBuilder:FormBuilder;

    Initialize(formBulder:FormBuilder,row: FBRowOptions) {
        this.FormBuilder=formBulder;
        this.Options=row;
        this.Columns=[];

        for(let column of row.Columns)
        {
            let columnInstance=this.GetColumnInstance();
            columnInstance.Initialize(this,column);
            this.Columns.push(columnInstance);
        }
    }

    public AppendElement()
    {
        this.Container=document.createElement('div');
        this.Container.classList.add('rednaoWooRow');
        this.FormBuilder.Container.appendChild(this.Container);

        for(let column of this.Columns)
        {
            column.AppendElement();
        }

    }

    protected GetColumnInstance(){
        return new FBColumn();
    }
}

 */